// extracted by mini-css-extract-plugin
module.exports = {"card":"LoadRateCard_card__3Qq6i"};